require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-meet-david-navy-veteran-turned-data-developer.json") })
        }
      }, "path---blog-meet-david-navy-veteran-turned-data-developer");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-meet-david-navy-veteran-turned-data-developer!./.cache/json/blog-meet-david-navy-veteran-turned-data-developer.json
// module id = 969
// module chunks = 231608221292675